//** Component  */
import React from "react";

//** Lib */
 
import BingoProductImportList from "./BingoProductImportList";
import CustomTab from "../../components/common/RenderTab/CustomTab";
import { hasFunctionalPermission } from "../../utils/AuthorizeNavigation/authorizeNavigation";
import { securityKey } from "../../navigation/SecurityKey";


function BingoProductImport() {

  const hasOpenTabPermission = hasFunctionalPermission(securityKey.BINGOPRODUCTIMPORTOPENTAB);
  const hasArchiveTabPermission = hasFunctionalPermission(securityKey.BINGOPRODUCTIMPORTARCHIVETAB);
  
  const data = [
    {
      id: "1",
      tabTitle: "Open",
      tabContent: < BingoProductImportList openStatus={1} />,
      isVisible: hasOpenTabPermission?.hasAccess,
    },
    {
      id: "2",
      tabTitle: "Archive",
      tabContent: <BingoProductImportList openStatus={2} />,
      isVisible: hasArchiveTabPermission?.hasAccess,
    },
  ];

  return (
    <>
       <CustomTab data={data} />
    </>
  );
}

export default BingoProductImport;
